module.exports = __webpack_public_path__ + "static/media/ProximaNova-ThinIt.0d23ced7.woff";